var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"justify-center text-center"},[_c('v-col',[_c('v-icon',{attrs:{"color":"warning"}},[_vm._v("mdi-information")]),_c('span',[_vm._t("default"),_c('br'),_c('v-btn',{staticClass:"mt-2",attrs:{"id":"routeToBaseData","to":{
          name: 'profil',
          params: { locale: _vm.locale, tabName: 'contact' }
        },"color":"primary"}},[_vm._v("\n        "+_vm._s(_vm.$t('button.invoice.data')))])],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }